const mutationTypes = {
  SET_SNACKBAR: 'SET_SNACKBAR',
  SET_PRESENTATION_MODE: 'SET_PRESENTATION_MODE',
}

const actionTypes = {
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  ENABLE_PRESENTATION_MODE: 'ENABLE_PRESENTATION_MODE',
  DISABLE_PRESENTATION_MODE: 'DISABLE_PRESENTATION_MODE',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/GlobalTypes.js